import HttpClient from "@soenergy/frontend-library/src/services/http/HttpClient"
import authenticate from "@soenergy/frontend-library/src/services/http/requestInterceptors/authenticate"

const apiClient = HttpClient({
  baseURL: `${process.env.VUE_APP_API_GATEWAY_URL}/smart-meter/`,
  requestInterceptors: [authenticate],
})

const apiGatewayV2Client = HttpClient({
  baseURL: process.env.VUE_APP_API_GATEWAY_URL_V2,
  requestInterceptors: [authenticate],
})

export default {
  getCustomerAvailability(billing_account_id) {
    return apiClient.get(`${billing_account_id}/register-interest`)
  },
  setCustomerAvailability(billing_account_id, data) {
    return apiClient.post(`${billing_account_id}/register-interest`, data)
  },
  getAvailableSlots(postcode, billing_account_id, mop, mpan, mprn) {
    return apiClient.get(
      `available-slots?postcode=${postcode}&billing_account_id=${billing_account_id}&mop=${mop}&mpan=${mpan}&mprn=${mprn}`
    )
  },
  createAppointment(data, accountId) {
    return apiClient.post(`${accountId}/create-booking`, data)
  },
  cancelBooking(accountId, jobNumber, reason, mop) {
    return apiClient.post(`${accountId}/cancel-booking`, {
      jobNumber,
      cancellationSource: "MY_ACCOUNT",
      reason,
      initiatedBy: "CUSTOMER",
      mop,
    })
  },
  getCancellationReasons() {
    return apiClient.get("appt-cancel-reason-config")
  },
  updateBooking(data) {
    return apiClient.patch("update-booking", data)
  },
  getBookings(accountId) {
    return apiClient.get(`${accountId}/get-bookings`)
  },
  getMeterRepairEligibility(accountId) {
    return apiClient.get(`${accountId}/meter-repair-eligibility`)
  },
  getMeterInstallEligibility(accountNumber) {
    return apiClient.get(`eligibility/${accountNumber}`)
  },
  getCustomerPsr(customerId) {
    return apiGatewayV2Client.get(`/api/v1/customers/${customerId}/psr`)
  },
  addCustomerPhoneNumber(customerId, phoneNumber) {
    return apiGatewayV2Client.post(
      `/api/v1/customers/${customerId}/phoneNumbers`,
      { phoneNumber }
    )
  },
}
